@if (viewModel && viewModel.category === 'sim') {
<ng-container [ngTemplateOutlet]="sim"></ng-container>
} @if (viewModel && viewModel.category === 'home') {
<ng-container [ngTemplateOutlet]="home"></ng-container>
} @if (viewModel && viewModel.category === 'entertainment') {
<ng-container [ngTemplateOutlet]="entertainment"></ng-container>
} @if ( viewModel && viewModel.category === 'Cybersecure') {
<ng-container [ngTemplateOutlet]="cybersecure"></ng-container>
}
<!-- SIM -->
<ng-template #sim>
  <h2
    class="h3 mb-0 py-2"
    [ngClass]="{ 'text-center': isMobileWidth() }"
    [attr.aria-label]="viewModel.section + ' de votre offre ' + offer.name"
  >
    <span data-e2e="item-title" class="item-title">{{viewModel.section}} </span>
  </h2>
  @if (isMobileWidth()) {
  <ng-container [ngTemplateOutlet]="simMobile" [ngTemplateOutletContext]="{ $implicit: viewModel }"></ng-container>
  } @else {
  <ng-container [ngTemplateOutlet]="simDesktop" [ngTemplateOutletContext]="{ $implicit: viewModel }"></ng-container>
  }
</ng-template>
<!-- SIM DESKTOP CONTENT -->
<ng-template #simDesktop let-viewModel>
  <div class="row no-gutters">
    <div class="col-3 align-self-center text-center">
      <img data-e2e="item-img" alt="" class="img-fluid w-auto dashboard-item-img" src="{{viewModel.imageUrl}}" />
    </div>
    <div class="col-9 pl-3 align-self-center">
      <ul class="items-list row">
        <li class="col-12">
          <a
            class="items-list-item dashboard-item-pos"
            (click)="openLink(viewModel.link, viewModel.trackingData, viewModel.contractId, $event); false"
            [href]="viewModel.link | link | async"
          >
            <div class="item-container">
              <div
                class="item-text"
                [attr.aria-label]="('dashboard.item.title' | translate) + ' ' + viewModel.name + ' ' + viewModel.id"
              >
                <span class="lead"><strong>{{"dashboard.item.title" | translate}} {{viewModel.name}}</strong></span>
                @if (viewModel?.id) {
                <span class="lead pb-0"><strong>{{viewModel.id}}</strong></span>
                }
                <small class="item-desc">{{viewModel.content}}</small>
              </div>
            </div>
          </a>
        </li>
        @if (optionsMobile) {
        <ng-container
          [ngTemplateOutlet]="simOptionsMobile"
          [ngTemplateOutletContext]="{$implicit: optionsMobile}"
        ></ng-container>
        } @if (viewModel?.subItems && viewModel?.subItems.length > 0) {
        <ng-container [ngTemplateOutlet]="simSubItems" [ngTemplateOutletContext]="{$implicit: viewModel?.subItems}">
        </ng-container>
        } @if (changeMobile) {
        <ng-container
          [ngTemplateOutlet]="simChangeMobile"
          [ngTemplateOutletContext]="{$implicit: changeMobile}"
        ></ng-container>
        } @if (multiSim && viewModel.isMultiSim) { @for (item of multiSim ; track item;) {
        <li class="col-12">
          <ng-container [ngTemplateOutlet]="simMultiSim" [ngTemplateOutletContext]="{$implicit: item}"></ng-container>
        </li>
        }}
      </ul>
    </div>
  </div>
</ng-template>
<!-- SIM MOBILE CONTENT -->
<ng-template #simMobile let-viewModel>
  <hr class="separator separator--gray4" />
  <ul class="items-list row">
    <li class="col-12">
      <a
        class="items-list-item dashboard-item-pos"
        (click)="openLink(viewModel.link, viewModel.trackingData, viewModel.contractId, $event); false"
        [href]="viewModel.link | link | async"
      >
        <div class="item-container dashboard-anchor">
          <div class="item-text align-self-baseline">
            <span class="lead pt-0"><strong>{{"dashboard.item.title" | translate}} {{viewModel.name}}</strong></span>
            @if (viewModel?.id) {
            <span class="lead pb-0"><strong>{{viewModel.id}}</strong></span>
            }
            <small class="item-desc">{{viewModel.content}}</small>
          </div>
          <div class="ml-auto align-self-end">
            <img data-e2e="item-img" alt="" class="img-fluid dashboard-item-img" src="{{viewModel.imageUrl}}" />
          </div>
        </div>
      </a>
    </li>
    @if (optionsMobile) { @for (option of optionsMobile; track option) {
    <li class="col-12">
      <hr class="separator separator--gray4" />
    </li>
    <li class="col-12">
      <ng-container
        [ngTemplateOutlet]="simOptionsMobileHiddenDesktop"
        [ngTemplateOutletContext]="{$implicit: option}"
      ></ng-container>
    </li>
    } }
    <li class="col-12">
      <hr class="separator separator--gray4" />
    </li>
    <ng-container
      [ngTemplateOutlet]="simSubItemsHiddenDesktop"
      [ngTemplateOutletContext]="{$implicit: viewModel?.subItems}"
    >
    </ng-container>
    @if (changeMobile) {
    <li class="col-12">
      <hr class="separator separator--gray4" />
    </li>
    <ng-container
      [ngTemplateOutlet]="simChangeMobile"
      [ngTemplateOutletContext]="{$implicit: changeMobile}"
    ></ng-container>
    } @if (multiSim && viewModel.isMultiSim) { @for (item of multiSim ; track item; let isLast = $last) {
    <li class="col-12">
      <ng-container
        [ngTemplateOutlet]="simMultiSimHiddenDesktop"
        [ngTemplateOutletContext]="{$implicit: item, isLast: isLast}"
      ></ng-container>
    </li>
    } }
  </ul>
</ng-template>
<!-- HOME -->
<ng-template #home>
  @if (!first) {
  <h2
    class="h3 mb-0 py-2"
    [ngClass]="{ 'text-center': isMobileWidth() }"
    [attr.aria-label]="viewModel.section + ' de votre offre ' + offer.name"
  >
    <span data-e2e="item-title" class="item-title">{{sectionHome ? sectionHome : viewModel.section}}</span>
  </h2>
  @if (isMobileWidth()) {
  <hr class="separator separator--gray4" />
  } }
  <ng-container
    [ngTemplateOutlet]="isMobileWidth()?homeMobile:homeDesktop"
    [ngTemplateOutletContext]="{ $implicit: viewModel }"
  ></ng-container>
</ng-template>
<!-- HOME DESKTOP CONTENT -->
<ng-template #homeDesktop let-viewModel>
  <div class="row no-gutters">
    <div class="col-3 align-self-center text-center">
      <img data-e2e="item-img" alt="" class="img-fluid dashboard-item-img" src="{{viewModel.imageUrl}}" />
    </div>
    <div class="col-9 pl-3 align-self-center">
      <ul class="items-list row">
        <li class="col-12">
          <a
            class="items-list-item dashboard-item-pos"
            (click)="openLink(viewModel.link, viewModel.trackingData, viewModel.contractId, $event); false"
            [href]="viewModel.link | link | async"
          >
            <div class="item-container" [ngClass]="{'border-bottom-0': internetStatus.id === 'ECO_WEAK'}">
              <div class="item-text">
                <span
                  class="lead"
                  [attr.aria-label]="('dashboard.item.title' | translate) + ' ' + viewModel.name + ' ' + viewModel?.id + ' du ' + offer.name"
                  ><strong>{{"dashboard.item.title" | translate}} {{viewModel.name}}</strong></span
                >
                @if (viewModel?.id) {
                <span class="lead pb-0"><strong>{{viewModel.id}}</strong></span>
                }
                <small class="item-desc">{{viewModel.content}}</small>
                @if (viewModel.name === 'Livebox') { @if (internetStatus.id === 'ECO_WEAK' || internetStatus.id ===
                'ECO_DEEP') {
                <device-status [deviceStatus]="internetStatus" [loadingStatus]="true"></device-status>
                } @else {
                <device-status [deviceStatus]="internetStatus" [loadingStatus]="true"></device-status>
                <device-status [deviceStatus]="wifiStatus" [loadingStatus]="false"> </device-status>
                } } @if (viewModel.name === 'fixe') {
                <device-status [deviceStatus]="voipStatus" [loadingStatus]="true"></device-status>
                } @if (viewModel.contentFixe) {
                <div class="pb-1 mt-0 text-gray3">{{viewModel.contentFixe}}</div>
                }
              </div>
            </div>
          </a>
        </li>
        @if (internetStatus.id === 'ECO_WEAK' && viewModel.name === 'Livebox') {
        <li class="col-12">
          <div class="items-list-item">
            <div class="item-container">
              <a href="#" (click)="itemButtonEvent(internetStatus);false" class="btn btn-secondary mb-1"
                >{{"deviceStatus.button.label" | translate}}</a
              >
            </div>
          </div>
        </li>
        } @if (viewModel.section !== 'Internet et fixe') {
        <li class="col-12">
          <fixe-sub-item
            data-e2e="subitems"
            [fixeviewModel]="viewModel.subItems"
            [hideBorder]="last && !viewModel.button"
          ></fixe-sub-item>
        </li>
        } @if (help && last) {
        <li class="col-12">
          <a
            class="items-list-item dashboard-item-pos"
            (click)="openLink(help.link, help.trackingData, help.cid, $event); false"
            [ecmDisabledAction]="isDisabledEclairLink(help)"
            [href]="help.link | link | async"
          >
            <div class="item-container">
              <div class="item-text">
                <span class="lead font-weight-bold">{{help.text}}</span>
              </div>
            </div>
          </a>
        </li>
        }
      </ul>
    </div>
  </div>
</ng-template>
<!-- HOME MOBILE CONTENT -->
<ng-template #homeMobile let-viewModel>
  <ul class="items-list row">
    <li class="col-12">
      <a
        class="items-list-item dashboard-item-pos"
        (click)="openLink(viewModel.link, viewModel.trackingData, viewModel.contractId, $event); false"
        [href]="viewModel.link | link | async"
      >
        <div class="item-container dashboard-anchor">
          <div class="item-text align-self-baseline">
            <span
              class="lead pt-0"
              [attr.aria-label]="('dashboard.item.title' | translate) + ' ' + viewModel.name + ' ' + viewModel?.id + ' du ' + offer.name"
              ><strong>{{"dashboard.item.title" | translate}} {{viewModel.name}}</strong></span
            >
            @if (viewModel?.id) {
            <span class="lead pb-0"><strong>{{viewModel.id}}</strong></span>
            }
            <small class="item-desc">{{viewModel.content}}</small>
            @if (viewModel?.contentFixe) {
            <small class="item-desc">{{viewModel.contentFixe}}</small>
            }
          </div>
          <div class="ml-auto align-self-end">
            <img data-e2e="item-img" alt="" class="img-fluid dashboard-item-img" src="{{viewModel.imageUrl}}" />
          </div>
        </div>
      </a>
    </li>
    @if (viewModel.section !== 'Internet et fixe') {
    <ng-container>
      <li>
        <fixe-sub-item
          data-e2e="subitems"
          [fixeviewModel]="viewModel.subItems"
          [hideBorder]="last && !viewModel.button"
        ></fixe-sub-item>
      </li>
    </ng-container>
    }
  </ul>
  @if (last && help) {
  <ul class="items-list row">
    <li class="col-12">
      <a
        class="items-list-item dashboard-item-pos"
        (click)="openLink(help.link, help.trackingData, help.cid, $event); false"
        [href]="help.link | link | async"
      >
        <div class="item-container no-border-bottom">
          <div class="item-text">
            <span class="lead"><strong>{{help.text}}</strong></span>
          </div>
        </div>
      </a>
    </li>
  </ul>
  }
</ng-template>
<!-- ENTERTAINMENT -->
<ng-template #entertainment>
  <h2
    class="h3 mb-0 py-2"
    [ngClass]="{ 'text-center': isMobileWidth() }"
    [attr.aria-label]="viewModel.section + ' de votre offre ' + offer.name"
  >
    <span data-e2e="item-title" class="item-title">{{viewModel.section}} {{viewModel.id}}</span>
  </h2>
  @if (isMobileWidth()) {
  <ng-container
    [ngTemplateOutlet]="entertainmentMobile"
    [ngTemplateOutletContext]="{ $implicit: viewModel }"
  ></ng-container>
  } @else {
  <ng-container
    [ngTemplateOutlet]="entertainmentDesktop"
    [ngTemplateOutletContext]="{ $implicit: viewModel }"
  ></ng-container>
  }
</ng-template>
<!-- ENTERTAINMENT -->
<!-- ENTERTAINMENT DESKTOP CONTENT -->
<ng-template #entertainmentDesktop let-viewModel>
  <div class="row no-gutters">
    <div class="col-3 align-self-center text-center">
      <img data-e2e="item-img" alt="" class="img-fluid dashboard-item-img" src="{{viewModel.imageUrl}}" />
    </div>
    <div class="col-9 pl-3 align-self-center">
      <ul class="items-list row">
        <li class="col-12">
          <a
            class="items-list-item dashboard-item-pos"
            (click)="openLink(viewModel.link, viewModel.trackingData, viewModel.contractId, $event);false"
            [href]="viewModel.link | link | async"
          >
            <div class="item-container" [ngClass]="{'border-bottom-0': tvStatus.id === 'ECO_WEAK'}">
              <div class="item-text">
                @if (viewModel.isTv) {
                <span class="lead" [attr.aria-label]="viewModel.name + ' du ' + offer.name"
                  ><strong>{{viewModel.name}}</strong></span
                >
                } @else {
                <span
                  class="lead"
                  [attr.aria-label]="('dashboard.item.title' | translate) + ' ' + viewModel.name + ' du ' + offer.name"
                  ><strong>{{"dashboard.item.title" | translate}} {{viewModel.name}}</strong></span
                >
                }
                <small class="item-desc" [innerHTML]="formatContent(viewModel.content)"></small>
                @if (viewModel.name === 'TV') {
                <device-status [deviceStatus]="tvStatus" [loadingStatus]="true"></device-status>
                }
              </div>
            </div>
          </a>
        </li>
        @if (tvStatus.id === 'ECO_WEAK') {
        <li class="col-12">
          <div class="items-list-item">
            <div class="item-container">
              <a href="#" (click)="itemButtonEvent(tvStatus);(false)" class="btn btn-secondary mb-1"
                >{{"deviceStatus.button.label" | translate}}</a
              >
            </div>
          </div>
        </li>
        } @for (option of optionsTv; track option) {
        <li class="col-12">
          <a
            class="items-list-item dashboard-item-pos"
            (click)="openLink(option.link, option.trackingData, null, $event);false"
            [href]="option.link | link | async"
          >
            <div class="item-container">
              <div class="item-text">
                @if (option.name) {
                <span class="lead"><strong>{{option.name}}</strong></span>
                } @if (option.description) {
                <span class="lead"><strong>{{option.description}}</strong></span>
                }
              </div>
            </div>
          </a>
        </li>
        }
      </ul>
    </div>
  </div>
</ng-template>
<!-- ENTERTAINMENT MOBILE CONTENT -->
<ng-template #entertainmentMobile let-viewModel>
  <hr class="separator separator--gray4" />
  <ul class="items-list row">
    <li class="col-12">
      <a
        class="items-list-item dashboard-item-pos"
        (click)="openLink(viewModel.link, viewModel.trackingData, viewModel.contractId, $event); false"
        [href]="viewModel.link | link | async"
      >
        <div class="item-container dashboard-anchor">
          <div class="item-text align-self-baseline">
            @if (viewModel.isTv) {
            <span class="lead pt-0" [attr.aria-label]="viewModel.name + ' du ' + offer.name"
              ><strong>{{viewModel.name}}</strong></span
            >
            } @else {
            <span
              class="lead pt-0"
              [attr.aria-label]="('dashboard.item.title' | translate) + ' ' + viewModel.name + ' du ' + offer.name"
              ><strong>{{"dashboard.item.title" | translate}} {{viewModel.name}}</strong></span
            >
            }
            <small class="item-desc" [innerHTML]="formatContent(viewModel.content)"></small>
          </div>
          <div class="ml-auto align-self-end">
            <img data-e2e="item-img" alt="" class="img-fluid dashboard-item-img" src="{{viewModel.imageUrl}}" />
          </div>
        </div>
      </a>
    </li>
    @for (option of optionsTv; track option; let isLast = $last) {
    <li class="col-12">
      <a
        class="items-list-item dashboard-item-pos"
        (click)="openLink(option.link, option.trackingData, null, $event); false"
        [ecmDisabledAction]="isDisabledEclairLink(option)"
        [href]="option.link | link | async"
      >
        <div
          class="item-container dashboard-anchor"
          [ngClass]="{
                       'no-border-bottom': isLast}"
        >
          <div class="item-text align-self-baseline">
            @if (option.name) {
            <span class="lead pt-0" data-e2e="item-option-name" [attr.aria-label]="option.name + ' du ' + offer.name"
              ><strong>{{option.name}}</strong></span
            >
            } @if (option.description) {
            <span
              class="lead pt-0"
              data-e2e="item-option-description"
              [attr.aria-label]="option.description + ' du ' + offer.name"
              ><strong>{{option.description}}</strong></span
            >
            }
          </div>
        </div>
      </a>
    </li>
    }
  </ul>
</ng-template>

<!-- START CYBERSECURE SECTION -->
<ng-template #cybersecure>
  @if (isMobileWidth()) {
  <hr class="separator separator--large separator--gray2" />
  }
  <h2 class="h3 mb-0 py-2" [ngClass]="{ 'text-center': isMobileWidth() }" [attr.aria-label]="viewModel.section">
    <span data-e2e="item-title" class="item-title">{{viewModel.section}}</span>
  </h2>

  @if (isMobileWidth()) {
  <hr class="separator separator--gray4" />

  <!-- Mobile layout -->
  <ul class="items-list row">
    <li class="col-12">
      <a
        class="items-list-item dashboard-item-pos"
        (click)="openLink(viewModel.link, viewModel.trackingData, viewModel.contractId, $event);false"
        [href]="viewModel.link | link | async"
      >
        <div class="item-container dashboard-anchor">
          <div class="item-text align-self-baseline">
            <span class="lead pt-0" [attr.aria-label]="viewModel.name + ' du ' + offer.name"
              ><strong>{{viewModel.name}}</strong></span
            >
            <small class="item-desc" [innerHTML]="formatContent(viewModel.content)"></small>
          </div>
          <div class="ml-auto align-self-end">
            <img data-e2e="item-img" alt="" class="img-fluid dashboard-item-img" [src]="viewModel.imageUrl" />
          </div>
        </div>
      </a>
    </li>
  </ul>
  } @else {
  <!-- Desktop layout -->
  <div class="row no-gutters">
    <div class="col-3 align-self-center text-center">
      <img data-e2e="item-img" alt="" class="img-fluid dashboard-item-img" [src]="viewModel.imageUrl" />
    </div>
    <div class="col-9 pl-3 align-self-center">
      <a
        class="items-list-item dashboard-item-pos"
        (click)="openLink(viewModel.link, viewModel.trackingData, viewModel.contractId, $event);false"
        [href]="viewModel.link | link | async"
      >
        <div class="item-container" [ngClass]="border-bottom-0">
          <div class="item-text">
            <span class="lead" [attr.aria-label]="viewModel.name + ' du ' + offer.name"
              ><strong>{{viewModel.name}}</strong></span
            >
            <small class="item-desc" [innerHTML]="formatContent(viewModel.content)"></small>
          </div>
        </div>
      </a>
    </div>
  </div>
  }
</ng-template>
<!-- END CYBERSECURE SECTION -->

<!-- SIM MOBILE - SUB ITEMS -->
<!-- SIM - OPTIONS MOBILE -->
<ng-template #simOptionsMobile let-optionsMobile>
  @for (option of optionsMobile; track option) {
  <li class="col-12">
    <a
      class="items-list-item dashboard-item-pos"
      (click)="openLink(option.link, option.trackingData, null, $event);false"
      [href]="option.link | link | async"
    >
      <div class="item-container dashboard-anchor">
        <div class="item-text align-self-baseline">
          <span class="lead pt-0"><strong>{{option.name}}</strong></span>
          <small class="item-desc">{{option.description}}</small>
        </div>
      </div>
    </a>
  </li>
  }
</ng-template>
<!-- SIM - SUB ITEMS -->
<ng-template #simSubItems let-subItems>
  @for (subItem of subItems; track subItem) {
  <li class="col-12">
    <a
      class="items-list-item dashboard-item-pos"
      (click)="openLink(subItem.link, subItem.trackingData, subItem.cid, $event);false"
      [class.disable]="!subItem.link"
      [href]="subItem.link | link | async"
    >
      <div class="align-items-center" [ngClass]="{'item-container item-pt-25': subItem.link !== null}">
        @switch (subItem.type) { @case ('picto') {
        <picto-sub-item
          data-e2e="subitem"
          [viewModel]="subItem"
          [hideBorder]="$last && !viewModel.button"
        ></picto-sub-item>
        } @case ('gauge') {
        <gauge-sub-item
          data-e2e="subitem"
          [viewModel]="subItem"
          [offer]="offer"
          [hideBorder]="$last && !viewModel.button"
        ></gauge-sub-item>
        } }
      </div>
    </a>
  </li>
  }
</ng-template>
<!-- SIM => CHANGE MOBILE -->
<ng-template #simChangeMobile let-changeMobile>
  <li class="col-12 item-pt-25">
    <a
      ecmPushTracker
      [pdb-zid]="zid"
      [pdb-sc]="'adv'"
      [pdb-ta]="changeMobile.advTracker"
      [pdb-idc]="changeMobile.code"
      class="items-list-item dashboard-item-pos"
      (click)="extendedLinkService.openLink(changeMobile.relation); false"
      [href]="extendedLinkService.getLink(changeMobile.relation)"
      [ecmDisabledAction]="isDisabledEclairLink(changeMobile)"
    >
      <div
        class="item-container dashboard-anchor"
        [ngClass]="{
          'border-0': changeMobile && !multiSim && optionsMobile.length === 0 }"
      >
        <div class="item-text align-self-baseline">
          <span class="lead pt-0" [attr.aria-label]="('dashboard.item.changeMobile' | translate) + ' ' + viewModel.name"
            ><strong>{{changeMobile.title}}</strong></span
          >
          <div class="m-0 text-gray3" [ngClass]="{'item-mb-25': multiSim || optionsMobile.length !== 0 }">
            {{changeMobile.content}}
          </div>
        </div>
      </div>
    </a>
  </li>
</ng-template>
<!-- SIM => MULTISIM -->
<ng-template #simMultiSim let-item>
  <a
    class="items-list-item dashboard-item-pos"
    ecmPushTracker
    (click)="openLink(item.link, item.trackingData, item.contractId, $event); false"
    [href]="item.link | link | async"
  >
    <div class="item-container p-0">
      <div class="item-text">
        <div class="lead"><strong>{{item.name}}</strong></div>
      </div>
    </div>
  </a>
</ng-template>
<!-- HIDDEN DESKTOP -->
<!-- SIM => OPTIONS MOBILE HIDDEN DESKTOP -->
<ng-template #simOptionsMobileHiddenDesktop let-option>
  <a
    class="items-list-item dashboard-item-pos"
    (click)="openLink(option.link, option.trackingData, null, $event); false"
    [ecmDisabledAction]="isDisabledEclairLink(option)"
    [href]="option.link | link | async"
  >
    <div class="item-container align-items-center item-pt-25 p-0">
      <div class="item-text">
        <span class="lead font-weight-bold item-pb-10"> {{option.name}}</span>
        <div class="m-0 item-mb-25 sub-item-grey">{{option.description}}</div>
      </div>
    </div>
  </a>
</ng-template>
<!-- SIM => SUB ITEMS HIDDEN DESKTOP -->
<ng-template #simSubItemsHiddenDesktop let-subItems>
  @for (subItem of subItems; track subItem) {
  <li class="col-12 column">
    <a
      class="items-list-item dashboard-item-pos"
      (click)="openLink(subItem.link, subItem.trackingData, subItem.cid, $event); false"
      [class.disable]="!subItem.link"
      [href]="subItem.link | link | async"
    >
      <div
        class="anchor-align-mobile p-0 item-container item-pt-25 item-pb-25"
        [ngClass]="{'border-0': !simChangeMobile && $last }"
      >
        @switch (subItem.type) { @case ('picto') {
        <picto-sub-item
          data-e2e="subitem"
          [viewModel]="subItem"
          [hideBorder]="$last && !viewModel.button"
        ></picto-sub-item>
        } @case ('gauge') {
        <gauge-sub-item
          data-e2e="subitem"
          [viewModel]="subItem"
          [offer]="offer"
          [hideBorder]="$last && !viewModel.button"
        ></gauge-sub-item>
        } }
      </div>
    </a>
  </li>
  }
</ng-template>
<!-- SIM => MULTISIM -->
<ng-template #simMultiSimHiddenDesktop let-item let-isLast="isLast">
  <hr class="separator separator--gray4" />

  <a
    class="items-list-item dashboard-item-pos"
    ecmPushTracker
    (click)="openLink(item.link, item.trackingData, item.contractId, $event); false"
    [href]="item.link | link | async"
  >
    <div class="item-container">
      <div class="item-text">
        <span class="lead"><strong>{{item.name}}</strong></span>
      </div>
    </div>
  </a>
</ng-template>
